import BreadcrumbView from "../common/breadcrumb/breadcrumb.html";
import FilesTypesWhitelistListView from "./files_types_whitelist-list.html";
import FilesTypesWhitelistEditView from "./files_types_whitelist-edit.html";


angular.module("files_types_whitelist", [])

    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('files_types_whitelist', {
                url: "/files_types_whitelist",
                abstract: true,
                controller: "BreadcrumbCtrl",
                template: BreadcrumbView,
            })

            .state('files_types_whitelist.list', {
                url: "/list",
                controller: "FilesTypesWhitelistListCtrl",
                template: FilesTypesWhitelistListView,
                requiredPermission: ["EVENTS_TYPES_READ"]
            })             
            .state('files_types_whitelist.edit', {
                url: "/edit/:id",
                controller: "FilesTypesWhitelistEditCtrl",
                template: FilesTypesWhitelistEditView,
                requiredPermission: ["EVENTS_TYPES_READ"]
            })
    }])
;